import DOMPurify from 'dompurify';

const previewInteractiveTags = ['a', 'button', 'form', 'input', 'select', 'textarea'];

export const sanitizeDocumentHtml = (value: string, readOnlyPreview: boolean) =>
    DOMPurify.sanitize(value, {
        ADD_ATTR: ['target'],
        ...(readOnlyPreview
            ? {
                  FORBID_TAGS: previewInteractiveTags,
                  FORBID_ATTR: ['action', 'formaction', 'href', 'target'],
              }
            : {}),
    });
